export enum ArticleFeature {
	TopicHighlight = "topic_highlight",
	Summary = "summary",
	QA = "qa",
	QAHighlight = "qa_highlight",
	Table = "table",
	Equation = "equation",
	Figure = "figure",
}